import Employee from "@/employee/Employee"
import ValueMod from "@/effects/ValueMod"
import util from "@/util"
import { Personality } from "@/employee/Personality"

export class ScholarPersonality extends Personality {
    id: string = 'scholar'
    affix: string = 'suffix'

    description(): string {
      return `Scholars will be less happy if they don't feel intelligent, but contribute more to science generation.`
    }

    get constantMods(): { [key: string]: [ValueMod] } {
      return {
        "researchMul": [new ValueMod(1.25, 'mul')],
      }
    }

    onUpdate(dt: number, employee: Employee) {
      employee.mood.valueMods.bimboPersonality = new ValueMod(
        util.clamp((employee.iq.fraction - 0.5) * 2 * 60, -30, 30), 'add'
      )
    }
}
